import { CircularProgress } from "@mui/material";
import React from "react";

const DynamicLoading = () => {
  return (
    <div className="w-full flex flex-row justify-center pt-3">
      <CircularProgress size={24} color="primary" />
    </div>
  );
};

export default DynamicLoading;
